import React from "reactn";
import { Formik } from "formik";
import * as Yup from "yup";

import { Form, TextInputField } from "@jsluna/form";

import {
  SubmitButton,
  Notification,
  NotificationStatuses,
  Card,
} from "@jsainsburyplc/id-ui-common";

import { EMAIL_REGEX } from "utils/validation";
import {
  CHECK_EMAIL_ERR,
  INVALID_EMAIL_MESSAGE,
  EMAIL_IS_REQUIRED_MESSAGE,
} from "constants/messages";

const EMAIL = "email";

const FORM_SCHEMA = Yup.object({
  email: Yup.string()
    .matches(EMAIL_REGEX, INVALID_EMAIL_MESSAGE)
    .required(EMAIL_IS_REQUIRED_MESSAGE),
});

const initialValues = {
  [EMAIL]: "",
};

const InitiateRegistrationForm = ({ onSubmit }) => (
  <section className="ln-o-section">
    <Formik
      initialValues={initialValues}
      validationSchema={FORM_SCHEMA}
      validateOnMount={true}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        getFieldProps,
        errors,
        isSubmitting,
        isValid,
        touched,
        status = {},
      }) => (
        <>
          {status.isError && (
            <div className="ln-u-margin-bottom*2">
              <Notification type={NotificationStatuses.ERROR_TYPE}>
                {CHECK_EMAIL_ERR}
              </Notification>
            </div>
          )}
          <Card>
            <Form onSubmit={handleSubmit} id="emailVerify">
              <TextInputField
                {...getFieldProps("email")}
                name={EMAIL}
                type={EMAIL}
                label="Email address"
                placeholder="Enter your email address"
                maxLength={128}
                error={touched.email && errors?.email}
                required
              />

              <div className="ln-u-text-align-center">
                <SubmitButton
                  submitHandler={handleSubmit}
                  label="Continue"
                  isLoadingLabel="Continue..."
                  fullWidth={true}
                  isLoading={isSubmitting}
                  disabled={isSubmitting || !isValid}
                />
              </div>
            </Form>
          </Card>
        </>
      )}
    </Formik>
  </section>
);

export default InitiateRegistrationForm;
